import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/mivena.webp';
import screenshot_target from '../../../images/letterfunnel/coertrasenberg.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Coert Rasenberg"
      firstname="Coert"
      companyname="Mivena"
      competition="ICL Growing Solutions en Haifa Group"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/coertrasenberg.js